import { styles } from "src/lib/styles";
import styled from "styled-components";

export const TableBody = styled.tbody`
    @media screen and (max-width: ${styles.mobileBreakPoint}) {
        display: flex;
        flex-direction: column;
        width: 100%;
    }
`;